export default __webpack_public_path__ + "static/media/Epic.d8802c91.svg";